import React from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import {ChakraSettings} from '../Icons/Carbon';
import {DisconnectIntegrationModal} from './DisconnectIntegrationModal';
import {DeleteIntegrationModal} from './DeleteIntegrationModal';
import {useCrmIntegrationFromContext} from './IntegrationDetailsContext';

export const CrmIntegrationActionMenu = ({
  disconnectInfoMessage,
  deleteWarningMessage,
}: {
  disconnectInfoMessage?: string;
  deleteWarningMessage?: string;
}) => {
  const integration = useCrmIntegrationFromContext();
  const disconnectIntegrationDisclosure = useDisclosure();
  const deleteIntegrationDisclosure = useDisclosure();

  return (
    <>
      <Menu>
        <MenuButton as={Button}>
          <ChakraSettings />
        </MenuButton>
        <MenuList>
          <MenuItem
            isDisabled={integration.status === 'disconnected'}
            onClick={disconnectIntegrationDisclosure.onOpen}
          >
            Disconnect
          </MenuItem>
          <MenuItem onClick={deleteIntegrationDisclosure.onOpen}>
            Delete
          </MenuItem>
        </MenuList>
      </Menu>
      <DisconnectIntegrationModal
        isOpen={disconnectIntegrationDisclosure.isOpen}
        onClose={disconnectIntegrationDisclosure.onClose}
        integrationType={integration.type}
        infoMessage={disconnectInfoMessage}
      />
      <DeleteIntegrationModal
        isOpen={deleteIntegrationDisclosure.isOpen}
        onClose={deleteIntegrationDisclosure.onClose}
        warningMessage={deleteWarningMessage}
      />
    </>
  );
};
